import { Layout, LayoutProps, AppBar } from 'react-admin';
import { Box } from '@mui/material';
import { UserAvatar } from './UserAvatar';
import { DebugModeToggle } from '../../../shared/components/DebugModeToggle';

const CustomAppBar = () => (
  <AppBar userMenu={<UserAvatar />}>
    <Box sx={{ flex: 1 }} />
    <DebugModeToggle />
  </AppBar>
);

export const AppLayout = (props: LayoutProps) => (
  <Layout {...props} appBar={CustomAppBar} />
);
